import React from 'react';
import { useIntl } from 'react-intl';

import { Layout } from '@components/layout';
import { SearchView } from '@components/searchView';

const Index = () => {
  const intl = useIntl();
  const headerTitle = intl.formatMessage({
    id: 'search.headerTitle',
    defaultMessage: 'Search PLATFORM | Discover Art',
  });
  const headerDescription = intl.formatMessage({
    id: 'search.headerDescription',
    defaultMessage: "Search all of PLATFORM's available works on this page to discover art you love.",
  });

  return (
    <Layout title={headerTitle} defaultDescription={headerDescription}>
      <SearchView />
    </Layout>
  );
};

export default Index;
